module.exports = __webpack_public_path__ + "img/DSC_7723.fa92b908.jpg";